import * as Yup from 'yup'
import { schema } from '../../utils/schemaValidation'
import { attributesItems } from './attributesItems'
import { generalItems } from './generalItems'
import { inconveniencesItems } from './inconveniencesItems'
import {
  getInitialState,
  optionListByKey as optLK,
  OTHERS_STATE,
} from '../../utils/formikUpdate'
import { optionsForSchema as optFS } from '../../utils/formikUpdate'
import * as service from '../../services'

export const setItemsFormik = async data => {
  const { properties } = data || {}
  const { attributes: attr, inconveniences: incv } = properties || {}
  const { res: attributes } = await service.getMetaFeaturesAll()
  const { res: ctgTypeAll } = await service.getCategoryTypeAll()

  const ITEMS_GENERAL_FORMIK = await generalItems()
  const ITEMS_ATTRIBUTES_FORMIK = await attributesItems(attr)
  const ITEMS_INCONVENIENCE_FORMIK = await inconveniencesItems(incv)

  const GENERAL = getInitialState(ITEMS_GENERAL_FORMIK)
  const ATTRIBUTE = getInitialState(ITEMS_ATTRIBUTES_FORMIK)
  const INCONVENIENCES = getInitialState(ITEMS_INCONVENIENCE_FORMIK)

  const INITIAL_FORMIK_STATE = {
    ...OTHERS_STATE,
    ...GENERAL,
    ...ATTRIBUTE,
    ...INCONVENIENCES,
  }

  const FORM_VALIDATION = Yup.object().shape(
    {
      //Generals
      ...schema.PARISH,
      ...schema.TYPE_SECTION,
      ...schema.RECORDED,
      ...schema.ALIVE,
      ...schema.TREEVERIFIED,
      ...schema.COMMIT,
      //Features
      ...schema.ALTITUDE,
      ...schema.CAP,
      ...schema.DAP,
      ...schema.HT,
      ...schema.HC,
      ...schema.CROWN_NS,
      ...schema.CROWN_EW,
      ...schema.FOLIAGE,
      ...schema.MATURITY(optLK('madurez', attributes)),
      ...schema.BLOOMING(optLK('floracion', attributes)),
      ...schema.FRUCTIFICATION(optLK('fructificacion', attributes)),
      ...schema.STRAIGHTNESS(optLK('fusteRectitud', attributes)),
      ...schema.SPACING(optLK('espaciamiento', attributes)),
      //Inconveniences
      ...schema.ROOTQUALITY(optFS('calidadRaiz', ctgTypeAll)),
      ...schema.FUSTEQUALITY(optFS('calidadFuste', ctgTypeAll)),
      ...schema.BARKQUALITY(optFS('calidadCorteza', ctgTypeAll)),
      ...schema.BRANCHESQUALITY(optFS('calidadRamas', ctgTypeAll)),
      ...schema.LEAVESQUALITY(optFS('calidadHojas', ctgTypeAll)),
      ...schema.TOPQUALITY(optFS('calidadCima', ctgTypeAll)),
      ...schema.CROWNQUALITY(optFS('calidadCopa', ctgTypeAll)),
      ...schema.RISKFALLING(optFS('rsgoCaida', ctgTypeAll)),
      ...schema.CONSTRUCTIONRISK(optFS('rsgoAfeccionConstr', ctgTypeAll)),
      ...schema.INTERFCIRCULATION(optFS('rsgoInterfCirculacion', ctgTypeAll)),
      ...schema.INFRASTRUCTURERISK(optFS('rsgoInfraestructura', ctgTypeAll)),
      ...schema.ELECTRICALNETWORKSRISK(optFS('rsgoRedesElectricas', ctgTypeAll)),
      ...schema.OTHERSRISK,
    },
    [
      ['riesgoOtros', 'riesgoOtros'],
      ['madurez', 'madurez'],
      ['floracion', 'floracion'],
      ['fructificacion', 'fructificacion'],
      ['fusteRectitud', 'fusteRectitud'],
      ['espaciamiento', 'espaciamiento'],
      ['calidadRaiz', 'calidadRaiz'],
      ['calidadFuste', 'calidadFuste'],
      ['calidadCorteza', 'calidadCorteza'],
      ['calidadRamas', 'calidadRamas'],
      ['calidadHojas', 'calidadHojas'],
      ['calidadCima', 'calidadCima'],
      ['calidadCopa', 'calidadCopa'],
      ['rsgoCaida', 'rsgoCaida'],
      ['rsgoAfeccionConstr', 'rsgoAfeccionConstr'],
      ['rsgoInterfCirculacion', 'rsgoInterfCirculacion'],
      ['rsgoInfraestructura', 'rsgoInfraestructura'],
      ['rsgoRedesElectricas', 'rsgoRedesElectricas'],
    ]
  )

  return {
    ITEMS_GENERAL_FORMIK,
    ITEMS_ATTRIBUTES_FORMIK,
    ITEMS_INCONVENIENCE_FORMIK,
    INITIAL_FORMIK_STATE,
    FORM_VALIDATION,
  }
}
